'use strict'

tracky = require '../old/groupon_modules/trackEvent'

###
# In-memory mock for local / sessionStorage
# It is not persistent across pages.
###
polyfillStore = ->
  Storage::_data = {}
  Storage::setItem = (id, val) -> this._data[id] = String(val)
  Storage::getItem = (id) -> if this._data.hasOwnProperty(id) then this._data[id] else null
  Storage::removeItem = (id) -> delete this._data[id]
  Storage::clear = -> this._data = {}
  return
###*
# Tries to use the sessionStorage setter, which fails in Safari incognito
#
# @param {String} env - SLS environment (desktop, touch, M16) to pass to tracky event
###
incognitoTest = (env = 'desktop') ->
  try
    sessionStorage?.setItem('incognitotest', 'test')
    Groupon?.PageFlags?.isIncognito = false
  catch
    tracky "ls-likely-incognito-session-#{ env }"
    Groupon?.PageFlags?.isIncognito = true
    polyfillStore()
  return

module.exports = {
  incognitoTest
  polyfillStore
}
